import React from 'react'
import FranceServiceMain from './FranceServiceMain'
import "./../../UaeAttestation/UaeService/UaeService.css";
import UaeServiceHead from '../../UaeAttestation/UaeService/UaeServiceHead';

const FranceService = () => {
  return (
    <div className="uaeServiceContainer">
    <UaeServiceHead head="France Apostille Services in Bangalore" />
    <FranceServiceMain />
  </div>
  )
}

export default FranceService
